export default function blocklistReducer(blocklist, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "addRule":
      return { ...blocklist, rules: [...blocklist.rules, action.rule] };
    case "updateRule":
      return {
        ...blocklist,
        rules: blocklist.rules.map((_rule) => {
          if (_rule.id === action.rule.id) {
            _rule = action.rule;
          }
          return _rule;
        }),
      };
    case "deleteRule": {
      return { ...blocklist, rules: blocklist.rules.filter((_rule) => _rule.id !== action.rule.id) };
    }

    default:
      return { ...blocklist, [action.type]: action.value };
  }
}
